import React, { useEffect, useRef, useState } from 'react'
import { Card, Form, Button, Row, Col, Spin, Table } from 'antd'
import moment from 'moment'
import { wtGetFromLocalStorage } from 'src/helpers/commons/LocalStorage'
import { wtApiCall } from 'src/helpers/commons/ApiWrapper'
import { lzNotifyErrorMessageFromResult } from 'src/helpers/commons/notifications'
import { wtRoundValue } from 'src/helpers/commons/utils'
import WidgetDatePicker from 'src/widgets/DatePickers/WidgetDatePicker'
import WidgetItemSelector from 'src/widgets/Selectors/WidgetItemSelector'
import BaseListing from 'src/BaseListings'
import { useDownloadExcel } from 'react-export-table-to-excel'

const StockDetailedReport = () => {
  const [form] = Form.useForm()
  const tableRef = useRef(null)

  const [isLoading, setIsLoading] = useState(false)
  const [dateRange, setDateRange] = useState(moment().format('YYYY-MM-DD'))
  const [stockData, setStockData] = useState([])
  const [warehouses, setWarehouses] = useState([])
  const [items, setItems] = useState([])
  const [itemId, setItemId] = useState(0)
  const [itemName, setItemName] = useState('')

  const Base = new BaseListing('stock_report')
  const companyName = wtGetFromLocalStorage('company_name')

  useEffect(() => {
    Base.dropdownData('items', {}, [setItems], 1)
  }, [])

  const getReportData = () => {
    setIsLoading(true)

    wtApiCall(
      'reports/stock_detailed_report',
      {
        date: dateRange,
        item_id: itemId || null,
      },
      'get',
      (response) => {
        if (response?.data) {
          setStockData(response.data.data || [])
          setWarehouses(response.data.warehouses || [])
        } else {
          setStockData([])
          setWarehouses([])
        }
        setIsLoading(false)
      },
      (error) => {
        lzNotifyErrorMessageFromResult(error)
        setIsLoading(false)
      },
    )
  }

  // 🔹 Dynamic warehouse columns
  const warehouseColumns = warehouses.map((wh) => ({
    title: wh.name,
    dataIndex: `warehouse_${wh.id}`,
    key: `warehouse_${wh.id}`,
    align: 'right',
    render: (value) => wtRoundValue(value || 0, 0),
  }))

  const columns = [
    { title: 'Item Code', dataIndex: 'item_code', fixed: 'left', width: 120 },
    { title: 'Item Name', dataIndex: 'item_name', fixed: 'left', width: 250 }, // <-- increase width
    { title: 'Brand', dataIndex: 'item_brand', fixed: 'left', width: 150 },
    { title: 'Unit', dataIndex: 'unit', fixed: 'left', width: 120 },
    ...warehouseColumns.map((col) => ({ ...col, width: 120 })),
    {
      title: 'Total',
      dataIndex: 'total_qty',
      key: 'total_qty',
      align: 'right',
      fixed: 'right',
      width: 120,
      render: (value) => wtRoundValue(value || 0, 0),
    }
  ]


  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: 'Stock Detailed Report',
    sheet: 'Stock',
  })

  return (
    <div className="container-fluid" style={{ padding: 20, background: '#fff' }}>
      <Card
        title={
          <h4 style={{ textAlign: 'center' }}>
            {companyName} – Stock Detailed Report
          </h4>
        }
      >
        <Row gutter={24}>
          <Col md={5}>
            <label>As Of *</label>
            <WidgetDatePicker value={dateRange} setDate={setDateRange} />
          </Col>

          <Col md={6}>
            <label>Item</label>
            <WidgetItemSelector
              items={items}
              value={itemId}
              displayValue={itemName}
              onChange={(val) => {
                setItemId(val?.value || 0)
                setItemName(val?.label || '')
              }}
              placeHolder="All Items"
            />
          </Col>

          <Col md={6} style={{ marginTop: 28 }}>
            <Button type="primary" onClick={getReportData} loading={isLoading}>
              Generate
            </Button>

            <Button
              style={{ marginLeft: 10, background: 'green', color: '#fff' }}
              onClick={onDownload}
            >
              Export Excel
            </Button>
          </Col>
        </Row>

        <br />

        <div ref={tableRef}>
          <Table
            columns={columns}
            dataSource={stockData}
            rowKey={(row, index) => index}
            bordered
            size="small"
            pagination={false}
            loading={{ spinning: isLoading, indicator: <Spin /> }}
            scroll={{
              x: warehouses.length * 120 + 600,
            }}
          />

        </div>
      </Card>
    </div>
  )
}

export default StockDetailedReport
